<template>
	<div class="Anexo2_tabelas">
		
		<h1>TABELA DE TAXAS</h1>

		<div>
			<table class="quadro">
				<caption>Taxas para exame e verificação dos pedidos de documentos de controle da atividade edilícia (R$)</caption>
				<thead>
					<tr>
						<th rowspan="2">
							<p class="corpo_quadro">DOCUMENTO</p>
						</th>
						<th rowspan="2">
							<p class="corpo_quadro">TIPIFICAÇÃO</p>
						</th>
						<th rowspan="2">
							<p class="corpo_quadro">UNIDADE</p>
						</th>
						<th rowspan="2">
							<p class="corpo_quadro">RESIDÊNCIA UNIFAMIIAR</p>
						</th>
						<th colspan="3">
							<p class="corpo_quadro">OUTROS USOS (ÁREA CONSTRUÍDA)</p>
						</th>
						<th rowspan="2">
							<p class="corpo_quadro">OBSERVAÇÃO</p>
						</th>
					</tr>
					<tr>
						<th>
							<p class="corpo_quadro">até  1.500m²</p>
						</th>
						<th>
							<p class="corpo_quadro">de 1.500 a 20.000m²</p>
						</th>
						<th>
							<p class="corpo_quadro">acima de 20.000m²</p>
						</th>
					</tr>
				</thead>
				<tbody>
					<tr>
						<td>
							<p class="corpo_quadro">Ficha técnica</p>
						</td>
						<td>
							<p class="corpo_quadro">Pedido</p>
						</td>
						<td>
							<p class="corpo_quadro">unidade</p>
						</td>
						<td>
							<p class="corpo_quadro">150,00</p>
						</td>
						<td>
							<p class="corpo_quadro">150,00</p>
						</td>
						<td>
							<p class="corpo_quadro">150,00</p>
						</td>
						<td>
							<p class="corpo_quadro">150,00</p>
						</td>
						<td>
							<p class="corpo_quadro">–</p>
						</td>
					</tr>
					<tr>
						<td>
							<p class="corpo_quadro">Diretrizes de Projeto</p>
						</td>
						<td>
							<p class="corpo_quadro">Pedido </p>
						</td>
						<td>
							<p class="corpo_quadro">m²</p>
						</td>
						<td>
							<p class="corpo_quadro">1,00</p>
						</td>
						<td>
							<p class="corpo_quadro">2,00</p>
						</td>
						<td>
							<p class="corpo_quadro">3,00</p>
						</td>
						<td>
							<p class="corpo_quadro">4,00</p>
						</td>
						<td>
							<p class="corpo_quadro">–</p>
						</td>
					</tr>
					<tr>
						<td rowspan="2">
							<p class="corpo_quadro">Alvará de Aprovação de edificação nova</p>
						</td>
						<td>
							<p class="corpo_quadro">Pedido inicial</p>
						</td>
						<td>
							<p class="corpo_quadro">m²</p>
						</td>
						<td>
							<p class="corpo_quadro">2,00</p>
						</td>
						<td>
							<p class="corpo_quadro">4,50</p>
						</td>
						<td>
							<p class="corpo_quadro">6,00</p>
						</td>
						<td>
							<p class="corpo_quadro">8,00</p>
						</td>
						<td rowspan="2">
							<p class="corpo_quadro">área a ser construída</p>
						</td>
					</tr>
					<tr>
						<td>
							<p class="corpo_quadro">Revalidação</p>
						</td>
						<td>
							<p class="corpo_quadro">m²</p>
						</td>
						<td>
							<p class="corpo_quadro">2,00</p>
						</td>
						<td>
							<p class="corpo_quadro">2,00</p>
						</td>
						<td>
							<p class="corpo_quadro">2,00</p>
						</td>
						<td>
							<p class="corpo_quadro">2,00</p>
						</td>
					</tr>
					<tr>
						<td rowspan="2">
							<p class="corpo_quadro">Alvará de Aprovação de reforma</p>
						</td>
						<td>
							<p class="corpo_quadro">Pedido inicial</p>
						</td>
						<td>
							<p class="corpo_quadro">m²</p>
						</td>
						<td>
							<p class="corpo_quadro">2,00</p>
						</td>
						<td>
							<p class="corpo_quadro">4,50</p>
						</td>
						<td>
							<p class="corpo_quadro">6,00</p>
						</td>
						<td>
							<p class="corpo_quadro">8,00</p>
						</td>
						<td rowspan="2">
							<p class="corpo_quadro">área a ser reformada</p>
						</td>
					</tr>
					<tr>
						<td>
							<p class="corpo_quadro">Revalidação</p>
						</td>
						<td>
							<p class="corpo_quadro">m²</p>
						</td>
						<td>
							<p class="corpo_quadro">2,00</p>
						</td>
						<td>
							<p class="corpo_quadro">2,00</p>
						</td>
						<td>
							<p class="corpo_quadro">2,00</p>
						</td>
						<td>
							<p class="corpo_quadro">2,00</p>
						</td>
					</tr>
					<tr>
						<td rowspan="2">
							<p class="corpo_quadro">Alvará de Aprovação de requalificação</p>
						</td>
						<td>
							<p class="corpo_quadro">Pedido inicial</p>
						</td>
						<td>
							<p class="corpo_quadro">m²</p>
						</td>
						<td>
							<p class="corpo_quadro">–</p>
						</td>
						<td>
							<p class="corpo_quadro">4,00</p>
						</td>
						<td>
							<p class="corpo_quadro">4,00</p>
						</td>
						<td>
							<p class="corpo_quadro">4,00</p>
						</td>
						<td rowspan="2">
							<p class="corpo_quadro">área a ser requalificada</p>
						</td>
					</tr>
					<tr>
						<td>
							<p class="corpo_quadro">Revalidação</p>
						</td>
						<td>
							<p class="corpo_quadro">m²</p>
						</td>
						<td>
							<p class="corpo_quadro">–</p>
						</td>
						<td>
							<p class="corpo_quadro">2,00</p>
						</td>
						<td>
							<p class="corpo_quadro">2,00</p>
						</td>
						<td>
							<p class="corpo_quadro">2,00</p>
						</td>
					</tr>
					<tr>
						<td rowspan="7">
							<p class="corpo_quadro">Alvará de Execução</p>
						</td>
						<td>
							<p class="corpo_quadro">Edificação nova</p>
						</td>
						<td>
							<p class="corpo_quadro">unidade</p>
						</td>
						<td>
							<p class="corpo_quadro">350,00</p>
						</td>
						<td>
							<p class="corpo_quadro">720,00</p>
						</td>
						<td>
							<p class="corpo_quadro">720,00</p>
						</td>
						<td>
							<p class="corpo_quadro">720,00</p>
						</td>
						<td>
							<p class="corpo_quadro">–</p>
						</td>
					</tr>
					<tr>
						<td>
							<p class="corpo_quadro">Reforma</p>
						</td>
						<td>
							<p class="corpo_quadro">unidade</p>
						</td>
						<td>
							<p class="corpo_quadro">350,00</p>
						</td>
						<td>
							<p class="corpo_quadro">720,00</p>
						</td>
						<td>
							<p class="corpo_quadro">720,00</p>
						</td>
						<td>
							<p class="corpo_quadro">720,00</p>
						</td>
						<td>
							<p class="corpo_quadro">–</p>
						</td>
					</tr>
					<tr>
						<td>
							<p class="corpo_quadro">Requalificação</p>
						</td>
						<td>
							<p class="corpo_quadro">unidade</p>
						</td>
						<td>
							<p class="corpo_quadro">350,00</p>
						</td>
						<td>
							<p class="corpo_quadro">720,00</p>
						</td>
						<td>
							<p class="corpo_quadro">720,00</p>
						</td>
						<td>
							<p class="corpo_quadro">720,00</p>
						</td>
						<td>
							<p class="corpo_quadro">–</p>
						</td>
					</tr>
					<tr>
						<td>
							<p class="corpo_quadro">Reconstrução</p>
						</td>
						<td>
							<p class="corpo_quadro">unidade</p>
						</td>
						<td>
							<p class="corpo_quadro">350,00</p>
						</td>
						<td>
							<p class="corpo_quadro">720,00</p>
						</td>
						<td>
							<p class="corpo_quadro">720,00</p>
						</td>
						<td>
							<p class="corpo_quadro">720,00</p>
						</td>
						<td>
							<p class="corpo_quadro">–</p>
						</td>
					</tr>
					<tr>
						<td>
							<p class="corpo_quadro">Demolição</p>
						</td>
						<td>
							<p class="corpo_quadro">unidade</p>
						</td>
						<td>
							<p class="corpo_quadro">350,00</p>
						</td>
						<td>
							<p class="corpo_quadro">720,00</p>
						</td>
						<td>
							<p class="corpo_quadro">720,00</p>
						</td>
						<td>
							<p class="corpo_quadro">720,00</p>
						</td>
						<td>
							<p class="corpo_quadro">–</p>
						</td>
					</tr>
					<tr>
						<td>
							<p class="corpo_quadro">Muro de arrimo</p>
						</td>
						<td>
							<p class="corpo_quadro">unidade</p>
						</td>
						<td>
							<p class="corpo_quadro">350,00</p>
						</td>
						<td>
							<p class="corpo_quadro">720,00</p>
						</td>
						<td>
							<p class="corpo_quadro">720,00</p>
						</td>
						<td>
							<p class="corpo_quadro">720,00</p>
						</td>
						<td>
							<p class="corpo_quadro">–</p>
						</td>
					</tr>
					<tr>
						<td>
							<p class="corpo_quadro">Movimento de ter terra</p>
						</td>
						<td>
							<p class="corpo_quadro">unidade</p>
						</td>
						<td>
							<p class="corpo_quadro">350,00</p>
						</td>
						<td>
							<p class="corpo_quadro">720,00</p>
						</td>
						<td>
							<p class="corpo_quadro">720,00</p>
						</td>
						<td>
							<p class="corpo_quadro">720,00</p>
						</td>
						<td>
							<p class="corpo_quadro">–</p>
						</td>
					</tr>
					<tr>
						<td rowspan="3">
							<p class="corpo_quadro">Projeto Modificativo</p>
						</td>
						<td>
							<p class="corpo_quadro">Edificação nova</p>
						</td>
						<td>
							<p class="corpo_quadro">m²</p>
						</td>
						<td>
							<p class="corpo_quadro">1,00</p>
						</td>
						<td>
							<p class="corpo_quadro">2,50</p>
						</td>
						<td>
							<p class="corpo_quadro">3,00</p>
						</td>
						<td>
							<p class="corpo_quadro">4,00</p>
						</td>
						<td>
							<p class="corpo_quadro">área a ser construída</p>
						</td>
					</tr>
					<tr>
						<td>
							<p class="corpo_quadro">Reforma</p>
						</td>
						<td>
							<p class="corpo_quadro">m²</p>
						</td>
						<td>
							<p class="corpo_quadro">0,50</p>
						</td>
						<td>
							<p class="corpo_quadro">1,00</p>
						</td>
						<td>
							<p class="corpo_quadro">2,00</p>
						</td>
						<td>
							<p class="corpo_quadro">3,00</p>
						</td>
						<td>
							<p class="corpo_quadro">área a ser reformada</p>
						</td>
					</tr>
					<tr>
						<td>
							<p class="corpo_quadro">Requalificação</p>
						</td>
						<td>
							<p class="corpo_quadro">m²</p>
						</td>
						<td>
							<p class="corpo_quadro">–</p>
						</td>
						<td>
							<p class="corpo_quadro">1,00</p>
						</td>
						<td>
							<p class="corpo_quadro">1,00</p>
						</td>
						<td>
							<p class="corpo_quadro">1,00</p>
						</td>
						<td>
							<p class="corpo_quadro">área a ser requalificada</p>
						</td>
					</tr>
					<tr>
						<td rowspan="3">
							<p class="corpo_quadro"><span class="notas">(VETADO)</span></p>
						</td>
						<td>
							<p class="corpo_quadro"><span class="notas">(VETADO)</span></p>
						</td>
						<td>
							<p class="corpo_quadro"><span class="notas">(VETADO)</span></p>
						</td>
						<td>
							<p class="corpo_quadro"><span class="notas">(VETADO)</span></p>
						</td>
						<td>
							<p class="corpo_quadro"><span class="notas">(VETADO)</span></p>
						</td>
						<td>
							<p class="corpo_quadro"><span class="notas">(VETADO)</span></p>
						</td>
						<td>
							<p class="corpo_quadro"><span class="notas">(VETADO)</span></p>
						</td>
						<td>
							<p class="corpo_quadro">–</p>
						</td>
					</tr>
					<tr>
						<td>
							<p class="corpo_quadro"><span class="notas">(VETADO)</span></p>
						</td>
						<td>
							<p class="corpo_quadro"><span class="notas">(VETADO)</span></p>
						</td>
						<td>
							<p class="corpo_quadro"><span class="notas">(VETADO)</span></p>
						</td>
						<td>
							<p class="corpo_quadro"><span class="notas">(VETADO)</span></p>
						</td>
						<td>
							<p class="corpo_quadro"><span class="notas">(VETADO)</span></p>
						</td>
						<td>
							<p class="corpo_quadro"><span class="notas">(VETADO)</span></p>
						</td>
						<td>
							<p class="corpo_quadro">–</p>
						</td>
					</tr>
					<tr>
						<td>
							<p class="corpo_quadro"><span class="notas">(VETADO)</span></p>
						</td>
						<td>
							<p class="corpo_quadro"><span class="notas">(VETADO)</span></p>
						</td>
						<td>
							<p class="corpo_quadro"><span class="notas">(VETADO)</span></p>
						</td>
						<td>
							<p class="corpo_quadro"><span class="notas">(VETADO)</span></p>
						</td>
						<td>
							<p class="corpo_quadro"><span class="notas">(VETADO)</span></p>
						</td>
						<td>
							<p class="corpo_quadro"><span class="notas">(VETADO)</span></p>
						</td>
						<td>
							<p class="corpo_quadro">–</p>
						</td>
					</tr>
					<tr>
						<td>
							<p class="corpo_quadro">Certificado de Conclusão</p>
						</td>
						<td>
							<p class="corpo_quadro">–</p>
						</td>
						<td>
							<p class="corpo_quadro">isento</p>
						</td>
						<td>
							<p class="corpo_quadro">–</p>
						</td>
						<td>
							<p class="corpo_quadro">–</p>
						</td>
						<td>
							<p class="corpo_quadro">–</p>
						</td>
						<td>
							<p class="corpo_quadro">–</p>
						</td>
						<td>
							<p class="corpo_quadro">–</p>
						</td>
					</tr>
					<tr>
						<td>
							<p class="corpo_quadro">Certificado de Regularização</p>
						</td>
						<td>
							<p class="corpo_quadro">–</p>
						</td>
						<td>
							<p class="corpo_quadro">m²</p>
						</td>
						<td>
							<p class="corpo_quadro">2,00</p>
						</td>
						<td>
							<p class="corpo_quadro">4,00</p>
						</td>
						<td>
							<p class="corpo_quadro">6,00</p>
						</td>
						<td>
							<p class="corpo_quadro">8,00</p>
						</td>
						<td>
							<p class="corpo_quadro">área a ser regularizada</p>
						</td>
					</tr>
					<tr>
						<td>
							<p class="corpo_quadro">Certificado de Acessibilidade</p>
						</td>
						<td>
							<p class="corpo_quadro">–</p>
						</td>
						<td>
							<p class="corpo_quadro">m²</p>
						</td>
						<td>
							<p class="corpo_quadro">–</p>
						</td>
						<td>
							<p class="corpo_quadro">2,00</p>
						</td>
						<td>
							<p class="corpo_quadro">3,00</p>
						</td>
						<td>
							<p class="corpo_quadro">4,00</p>
						</td>
						<td>
							<p class="corpo_quadro">área objeto do pedido</p>
						</td>
					</tr>
					<tr>
						<td>
							<p class="corpo_quadro">Certificado de Segurança</p>
						</td>
						<td>
							<p class="corpo_quadro">–</p>
						</td>
						<td>
							<p class="corpo_quadro">m²</p>
						</td>
						<td>
							<p class="corpo_quadro">–</p>
						</td>
						<td>
							<p class="corpo_quadro">2,00</p>
						</td>
						<td>
							<p class="corpo_quadro">2,00</p>
						</td>
						<td>
							<p class="corpo_quadro">4,00</p>
						</td>
						<td>
							<p class="corpo_quadro">área objeto do pedido</p>
						</td>
					</tr>
					<tr>
						<td rowspan="6">
							<p class="corpo_quadro">Alvará de Autorização</p>
						</td>
						<td>
							<p class="corpo_quadro">Implantação de edificação transitória</p>
						</td>
						<td>
							<p class="corpo_quadro">m²</p>
						</td>
						<td>
							<p class="corpo_quadro">–</p>
						</td>
						<td>
							<p class="corpo_quadro">2,00</p>
						</td>
						<td>
							<p class="corpo_quadro">2,00</p>
						</td>
						<td>
							<p class="corpo_quadro">2,00</p>
						</td>
						<td>
							<p class="corpo_quadro">–</p>
						</td>
					</tr>
					<tr>
						<td>
							<p class="corpo_quadro">Implantação de equipamento transitório</p>
						</td>
						<td>
							<p class="corpo_quadro">unidade</p>
						</td>
						<td>
							<p class="corpo_quadro">–</p>
						</td>
						<td>
							<p class="corpo_quadro">700,00</p>
						</td>
						<td>
							<p class="corpo_quadro">1.400,00</p>
						</td>
						<td>
							<p class="corpo_quadro">1.400,00</p>
						</td>
						<td>
							<p class="corpo_quadro">–</p>
						</td>
					</tr>
					<tr>
						<td>
							<p class="corpo_quadro">Utilização temporária de edificação licenciada para uso diverso </p>
						</td>
						<td>
							<p class="corpo_quadro">m²</p>
						</td>
						<td>
							<p class="corpo_quadro">–</p>
						</td>
						<td>
							<p class="corpo_quadro">2,00</p>
						</td>
						<td>
							<p class="corpo_quadro">2,00</p>
						</td>
						<td>
							<p class="corpo_quadro">2,00</p>
						</td>
						<td>
							<p class="corpo_quadro">–</p>
						</td>
					</tr>
					<tr>
						<td>
							<p class="corpo_quadro">Avanço do tapume sobre parte do passeio público</p>
						</td>
						<td>
							<p class="corpo_quadro">unidade</p>
						</td>
						<td>
							<p class="corpo_quadro">–</p>
						</td>
						<td>
							<p class="corpo_quadro">700,00</p>
						</td>
						<td>
							<p class="corpo_quadro">1.400,00</p>
						</td>
						<td>
							<p class="corpo_quadro">1.400,00</p>
						</td>
						<td>
							<p class="corpo_quadro">–</p>
						</td>
					</tr>
					<tr>
						<td>
							<p class="corpo_quadro">Avanço de grua sobre o espaço público</p>
						</td>
						<td>
							<p class="corpo_quadro">unidade</p>
						</td>
						<td>
							<p class="corpo_quadro">–</p>
						</td>
						<td>
							<p class="corpo_quadro">700,00</p>
						</td>
						<td>
							<p class="corpo_quadro">1.400,00</p>
						</td>
						<td>
							<p class="corpo_quadro">1.400,00</p>
						</td>
						<td>
							<p class="corpo_quadro">–</p>
						</td>
					</tr>
					<tr>
						<td>
							<p class="corpo_quadro">Instalação de canteiro de obras e estande de vendas em imóvel distinto</p>
						</td>
						<td>
							<p class="corpo_quadro">m²</p>
						</td>
						<td>
							<p class="corpo_quadro">–</p>
						</td>
						<td>
							<p class="corpo_quadro">2,00</p>
						</td>
						<td>
							<p class="corpo_quadro">2,00</p>
						</td>
						<td>
							<p class="corpo_quadro">2,00</p>
						</td>
						<td>
							<p class="corpo_quadro">área objeto do pedido</p>
						</td>
					</tr>
					<tr>
						<td rowspan="4">
							<p class="corpo_quadro">Cadastro de equipamento</p>
						</td>
						<td>
							<p class="corpo_quadro">Elevador</p>
						</td>
						<td>
							<p class="corpo_quadro">unidade</p>
						</td>
						<td>
							<p class="corpo_quadro">150,00</p>
						</td>
						<td>
							<p class="corpo_quadro">150,00</p>
						</td>
						<td>
							<p class="corpo_quadro">150,00</p>
						</td>
						<td>
							<p class="corpo_quadro">150,00</p>
						</td>
						<td>
							<p class="corpo_quadro">–</p>
						</td>
					</tr>
					<tr>
						<td>
							<p class="corpo_quadro">Equipamento mecânico de transporte permanente</p>
						</td>
						<td>
							<p class="corpo_quadro">unidade</p>
						</td>
						<td>
							<p class="corpo_quadro">150,00</p>
						</td>
						<td>
							<p class="corpo_quadro">150,00</p>
						</td>
						<td>
							<p class="corpo_quadro">150,00</p>
						</td>
						<td>
							<p class="corpo_quadro">150,00</p>
						</td>
						<td>
							<p class="corpo_quadro">–</p>
						</td>
					</tr>
					<tr>
						<td>
							<p class="corpo_quadro">Tanque de armazenagem, bomba, filtro de combustível e equipamentos afins</p>
						</td>
						<td>
							<p class="corpo_quadro">unidade</p>
						</td>
						<td>
							<p class="corpo_quadro">150,00</p>
						</td>
						<td>
							<p class="corpo_quadro">150,00</p>
						</td>
						<td>
							<p class="corpo_quadro">150,00</p>
						</td>
						<td>
							<p class="corpo_quadro">150,00</p>
						</td>
						<td>
							<p class="corpo_quadro">–</p>
						</td>
					</tr>
					<tr>
						<td>
							<p class="corpo_quadro">Sistema especial de segurança</p>
						</td>
						<td>
							<p class="corpo_quadro">m²</p>
						</td>
						<td>
							<p class="corpo_quadro">–</p>
						</td>
						<td>
							<p class="corpo_quadro">2,00</p>
						</td>
						<td>
							<p class="corpo_quadro">2,00</p>
						</td>
						<td>
							<p class="corpo_quadro">4,00</p>
						</td>
						<td>
							<p class="corpo_quadro">área objeto do pedido</p>
						</td>
					</tr>
					<tr>
						<td rowspan="4">
							<p class="corpo_quadro">Manutenção de equipamento</p>
						</td>
						<td>
							<p class="corpo_quadro">Elevador</p>
						</td>
						<td>
							<p class="corpo_quadro">unidade</p>
						</td>
						<td>
							<p class="corpo_quadro">150,00</p>
						</td>
						<td>
							<p class="corpo_quadro">150,00</p>
						</td>
						<td>
							<p class="corpo_quadro">150,00</p>
						</td>
						<td>
							<p class="corpo_quadro">150,00</p>
						</td>
						<td>
							<p class="corpo_quadro">–</p>
						</td>
					</tr>
					<tr>
						<td>
							<p class="corpo_quadro">Equipamento mecânico de transporte permanente</p>
						</td>
						<td>
							<p class="corpo_quadro">unidade</p>
						</td>
						<td>
							<p class="corpo_quadro">150,00</p>
						</td>
						<td>
							<p class="corpo_quadro">150,00</p>
						</td>
						<td>
							<p class="corpo_quadro">150,00</p>
						</td>
						<td>
							<p class="corpo_quadro">150,00</p>
						</td>
						<td>
							<p class="corpo_quadro">–</p>
						</td>
					</tr>
					<tr>
						<td>
							<p class="corpo_quadro">Tanque de armazenagem, bomba, filtro de combustível e equipamentos afins</p>
						</td>
						<td>
							<p class="corpo_quadro">unidade</p>
						</td>
						<td>
							<p class="corpo_quadro">150,00</p>
						</td>
						<td>
							<p class="corpo_quadro">150,00</p>
						</td>
						<td>
							<p class="corpo_quadro">150,00</p>
						</td>
						<td>
							<p class="corpo_quadro">150,00</p>
						</td>
						<td>
							<p class="corpo_quadro">–</p>
						</td>
					</tr>
					<tr>
						<td>
							<p class="corpo_quadro">Sistema especial de segurança</p>
						</td>
						<td>
							<p class="corpo_quadro">m²</p>
						</td>
						<td>
							<p class="corpo_quadro">–</p>
						</td>
						<td>
							<p class="corpo_quadro">2,00</p>
						</td>
						<td>
							<p class="corpo_quadro">2,00</p>
						</td>
						<td>
							<p class="corpo_quadro">4,00</p>
						</td>
						<td>
							<p class="corpo_quadro">área objeto do pedido</p>
						</td>
					</tr>
					<tr>
						<td>
							<p class="corpo_quadro">Recurso</p>
						</td>
						<td>
							<p class="corpo_quadro">–</p>
						</td>
						<td>
							<p class="corpo_quadro">unidade</p>
						</td>
						<td>
							<p class="corpo_quadro">350,00</p>
						</td>
						<td>
							<p class="corpo_quadro">700,00</p>
						</td>
						<td>
							<p class="corpo_quadro">1.400,00</p>
						</td>
						<td>
							<p class="corpo_quadro">1.400,00</p>
						</td>
						<td>
							<p class="corpo_quadro">–</p>
						</td>
					</tr>
					<tr>
						<td>
							<p class="corpo_quadro">Instalação de tapume</p>
						</td>
						<td>
							<p class="corpo_quadro">–</p>
						</td>
						<td>
							<p class="corpo_quadro">m</p>
						</td>
						<td>
							<p class="corpo_quadro">8,00</p>
						</td>
						<td>
							<p class="corpo_quadro">8,00</p>
						</td>
						<td>
							<p class="corpo_quadro">8,00</p>
						</td>
						<td>
							<p class="corpo_quadro">8,00</p>
						</td>
						<td>
							<p class="corpo_quadro">–</p>
						</td>
					</tr>
					<tr>
						<td>
							<p class="corpo_quadro">Transporte de terra ou entulho</p>
						</td>
						<td>
							<p class="corpo_quadro">–</p>
						</td>
						<td>
							<p class="corpo_quadro">valor fixo</p>
						</td>
						<td>
							<p class="corpo_quadro">150,00</p>
						</td>
						<td>
							<p class="corpo_quadro">150,00</p>
						</td>
						<td>
							<p class="corpo_quadro">150,00</p>
						</td>
						<td>
							<p class="corpo_quadro">150,00</p>
						</td>
						<td>
							<p class="corpo_quadro">–</p>
						</td>
					</tr>
					<tr>
						<td>
							<p class="corpo_quadro">Certidão de Alinhamento e Nivelamento</p>
						</td>
						<td>
							<p class="corpo_quadro">–</p>
						</td>
						<td>
							<p class="corpo_quadro">valor fixo</p>
						</td>
						<td>
							<p class="corpo_quadro">150,00</p>
						</td>
						<td>
							<p class="corpo_quadro">150,00</p>
						</td>
						<td>
							<p class="corpo_quadro">150,00</p>
						</td>
						<td>
							<p class="corpo_quadro">150,00</p>
						</td>
						<td>
							<p class="corpo_quadro">–</p>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
</template>

<script>
export default{
  name: "Anexo2_tabelas", 
  data(){
	return{
	  title: "Anexo 2 - Tabelas",
		props:['caminho']

	}
  }
}
</script>

<style lang="scss">
@import '../assets/main.scss';
</style>


// WEBPACK FOOTER //
// src/components/Anexo2_tabelas.vue